/*
======================================================
BYMOQA Dynamic Search
Version 2.0
======================================================
*/

window.initBymoqaSearch = function(app){

    const header = app.header;

    const searchButton =
        header.querySelector(".search-trigger");

    const closeButton =
        header.querySelector(".bymoqa-search-back");

    const searchShell =
        header.querySelector(".bymoqa-search-shell");

    const input =
        header.querySelector(".bymoqa-search-input");

    if(
        !searchButton ||
        !closeButton ||
        !searchShell ||
        !input
    ){
        return;
    }

    let isOpen = false;

    function openSearch(){

        if(isOpen) return;

        isOpen = true;

        header.classList.add("search-open");

        searchShell.setAttribute(
            "aria-hidden",
            "false"
        );

        setTimeout(()=>{

            input.focus(openSearch());

        },260);

    }

    function closeSearch(){

        if(!isOpen) return;

        isOpen = false;

        header.classList.remove("search-open");

        searchShell.setAttribute(
            "aria-hidden",
            "true"
        );

        searchButton.focus();

    }

    searchButton.addEventListener(
        "click",
        openSearch
    );

    closeButton.addEventListener(
        "click",
        closeSearch
    );

    document.addEventListener(
        "keydown",
        (event)=>{

            if(event.key==="Escape"){

                closeSearch();

            }

            if(
                event.key==="/" &&
                !isOpen &&
                document.activeElement.tagName!=="INPUT" &&
                document.activeElement.tagName!=="TEXTAREA"
            ){

                event.preventDefault();

                openSearch();

            }

        }
    );

    document.addEventListener(
        "click",
        (event)=>{

            if(!isOpen) return;

            if(
                header.contains(event.target)
            ) return;

            closeSearch();

        }
    );

    input.addEventListener(
        "keydown",
        (event)=>{

            if(event.key==="Escape"){

                closeSearch();

            }

        }
    );

    app.search.open = openSearch;
    app.search.close = closeSearch;

}